export default "__VITE_ASSET__a9c82f95__"